export class SmoothTransitionAnchorLinks {
    private readonly scrollOffset: number = 135;
    private isScrolling: boolean = false;

    constructor(offset?: number) {
        if (offset !== undefined) {
            this.scrollOffset = offset;
        }
    }

    public initialize(): void {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();

                const targetId = anchor.getAttribute('href');
                if (targetId && targetId !== '#') {
                    const targetElement = document.querySelector(targetId);

                    if (targetElement) {
                        this.scrollToElement(targetElement, targetId);
                    }
                }
            });
        });

        this.handleInitialHash();
    }

    private scrollToElement(element: Element, hash: string): void {
        if (this.isScrolling) return;

        this.isScrolling = true;

        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - this.scrollOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

        // Обновляем URL после завершения скролла
        const checkScrollEnd = () => {
            const currentPosition = window.pageYOffset;

            if (Math.abs(currentPosition - offsetPosition) < 5) {
                // Скролл завершен
                history.pushState(null, '', hash);
                this.isScrolling = false;
            } else {
                requestAnimationFrame(checkScrollEnd);
            }
        };

        setTimeout(checkScrollEnd, 50);
    }

    private handleInitialHash(): void {
        if (window.location.hash) {
            setTimeout(() => {
                const targetElement = document.querySelector(window.location.hash);
                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - this.scrollOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }
}
